(function($, undefined) {
	'use strict';
	var prev = '';
	var next = '';
	var end = '';
	var	gendataId;
	var	personId;
	var refresh;
	var leftMenuBtn;
	var leftMenu;
	var accountNav;
	var isDev;

	var initGuide = function(guide, total) {
		var name = guide;
		var steps = $('[data-guide-name=' + name + ']');
		var count = 0;
		var stepsSettings = [];
		var backdropActive = true;
		
		if(navigator.userAgent.indexOf('MSIE')!==-1
		|| navigator.appVersion.indexOf('Trident/') > -1){
		   /* Microsoft Internet Explorer detected */
			backdropActive = false;
		}

		var _stepsLoop = function() {
			var stepFound = false;
			var loopCounts = 0;
			
			steps.each(function() {
				var t = $(this);
				var respCondition = t.attr('data-guide-responsive');
				var show = true;
				loopCounts++;

				if (respCondition !== '') {
					// I KNOW C'EST LAID #TUCONNAISPAUL
					var respCssCheck = true;
					var respResolution;

					if (respCondition.indexOf('responsive') !== -1) {
						respResolution = respCondition.split('responsive-')[1];
						respCssCheck = $('.resp-detector-' + respResolution).css('visibility') === 'visible';
					} else if (respCondition.indexOf('desktop') !== -1) {
						respResolution = respCondition.split('desktop-')[1];
						respCssCheck = $('.resp-detector-' + respResolution).css('visibility') === 'hidden';
					}
					
					show = respCssCheck;
				}

				if (!show) {
					t.addClass('guide-ignore');
					steps = $(':not(.guide-ignore)[data-guide-name=' + name + ']');
				}

				if (t.data('guide-step') === count) {
					stepFound = true;
					if (show) {
						count++;

						var step = {
							element: $('#' + t.attr('id')),
							title: t.attr('data-guide-title'),
							content: t.attr('data-guide-content') ? t.attr('data-guide-content') : ' ',
							placement: t.attr('data-guide-placement') ? t.attr('data-guide-placement') : 'auto',
							backdropPadding: t.attr('data-guide-backdrop-padding') ? JSON.parse(t.attr('data-guide-backdrop-padding')) : 10,
							onShow: function(tour) {
								handleOnShow(tour);
							},
							onShown: function(tour) {
								handleOnShown(tour);
							},
							onNext: function(tour) {
								if (t.attr('data-guide-next').length > 0) {
									$(t.attr('data-guide-next')).first().trigger('click');
								} else {
									handleNextStepClick(tour);
								}
							},
							onPrev: function(tour) {
								if (t.attr('data-guide-prev').length > 0) {
									$(t.attr('data-guide-prev')).first().trigger('click');
								} else {
									handlePrevStepClick(tour);
								}
							},
						};

						stepsSettings.push(step);
					}
				}
			});

			if (isDev) {
				if (!stepFound) {
					console.log('step ' + name + ' #' + count + ' found: ' + stepFound);
				} else {
					console.log('step ' + name + ' found: ' + stepFound);
				}
			}

			if (count >= total) {
				var tour = new Tour({
					name: name,
					steps: stepsSettings,
					backdrop: backdropActive,
					template: `<div class="popover" role="tooltip">
							<div class="arrow"></div>
							<h3 class="popover-title"></h3>
							<div class="popover-content"></div>
							<div class="popover-navigation">
								<div class="btn-group full-width">
									<button class="btn btn-default small full grey" data-role="prev">` + prev + `</button>
									<button class="btn btn-default small full" data-role="next">` + next + `</button>
								</div>
								<button class="btn btn-default small mt10" data-role="end">` + end + `</button>
							</div>
						</div>`,
					onEnd: function(tour) {
						saveTourSeen(tour);
					}
				});

				tour.setCurrentStep(0);
				tour.init();
				tour.start(true);
			} else {
				// continue looping only if 1 step found or start looking for next step (prevent infinite loop)
				if (!stepFound) {
					count++;
				}
				_stepsLoop();
			}
		};

		_stepsLoop();
	};

	var handleOnShow = function(tour) {
		console.log(tour);

		// PAGE DASHBOARD - SEARCHER
		if (tour._options.name === 'searcher-field4') {
			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 0) {
					$('.mobile-side-menu.left').addClass('open');
				}
			}
		}
	};

	var handleOnShown = function(tour) {
		console.log(tour);

		// PAGE MODIF PROFIL - ARTISTE
		if (tour._options.name === 'artist-field6') {
			if (tour._current === 0) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=personnal-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE MODIF PROFIL - AGENCY
		if (tour._options.name === 'agency-field6') {
			if (tour._current === 0) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=personnal-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
		}
	};

	var handleNextStepClick = function(tour) {
		console.log(tour);

		// PAGE DASHBOARD - SEARCHER
		if (tour._options.name === 'searcher-field4') {
			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 2 || tour._current === 3 || tour._current === 4) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE AUDITION FORM - SEARCHER
		if (tour._options.name === 'searcher-field6') {
			if (tour._current === 2) {
				$('.audition-forms-step.audition-details .audition-forms-header').trigger('click');
			}
			if (tour._current === 6) {
				$('.audition-forms-step.audition-recording .audition-forms-header').trigger('click');
			}
			if (tour._current === 8) {
				$('.audition-forms-step.audition-contract .audition-forms-header').trigger('click');
			}
			if (tour._current === 9) {
				$('.audition-forms-step.audition-profile .audition-forms-header').trigger('click');
			}
		}

		// PAGE FICHE AUDITION - SEARCHER
		if (tour._options.name === 'searcher-field8') {
			if (tour._current === 2) {
				$('.audition-actions-btn').trigger('click');
			}
			// RESPONSIVE SIDE BREAKPOINT
			if ($('.resp-detector-side-bp').css('visibility') === 'visible') {
				if (tour._current === 0) {
					$('.audition-single-details-btn:not(.close)').trigger('click');
				}
				if (tour._current === 1) {
					$('.audition-single-details-btn.close').trigger('click');
				}
			}
		}

		// PAGE DASHBOARD - ARTIST
		if (tour._options.name === 'artist-field4') {
			if (tour._current === 0 || tour._current === 1) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.header-account-btn:not(.close)').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					$('.header-account-responsive-btn').trigger('click');
				}
			}

			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 2 || tour._current === 4) {
					leftMenuBtn.trigger('click');
				}
			}
		}
		
		// PAGE MODIF PROFIL - ARTISTE
		if (tour._options.name === 'artist-field6') {
			if (tour._current === 1) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=more-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('more-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 3) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=agency-link]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 7) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=preferences]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('preferences');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE FICHE AUDITION - ARTISTE
		if (tour._options.name === 'artist-field8') {
			if (tour._current === 1 || tour._current === 4) {
				$('.audition-actions-btn').trigger('click');
			}
		}

		// PAGE DASHBOARD - AGENCY
		if (tour._options.name === 'agency-field4') {
			if (tour._current === 0 || tour._current === 2) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.header-account-btn:not(.close)').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					$('.header-account-responsive-btn').trigger('click');
				}
			}

			// // RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 2 || tour._current === 6) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE MODIF PROFIL - AGENCY
		if (tour._options.name === 'agency-field6') {
			if (tour._current === 0) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('more-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 1) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 2) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('social');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 3) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('preferences');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 4) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 5) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 9) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('preferences');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE SUBSCRIPTIONS - AGENCY
		if (tour._options.name === 'agency-field9') {
			if (tour._current === 0) {
				$('.table-outer-ctn').animate({scrollLeft: $('.hijack-user-btn').position().left}, 300);
			}
			if (tour._current === 1) {
				$('.table-outer-ctn').animate({scrollLeft: $('.modify-artist-subscription-table-btn').position().left}, 300);
			}
			if (tour._current === 2) {
				if (!$('#agency-field9-2').closest('td').hasClass('open')) {
					$('#agency-field9-2').trigger('click');
				}
				$('.table-outer-ctn').animate({scrollLeft: $('.user-subscription-modif-form').position().left}, 300);
			}
			if (tour._current === 3 && $('#agency-field9-3').closest('form').find('[data-id=cc-box-form]').css('display') === 'none') {
				$('#agency-field9-3').find('[name=useCardPersonId]').val('new-card');
				$('#agency-field9-3').find('[name=useCardPersonId]').trigger('change');
			}
		}
	};

	var handlePrevStepClick = function(tour) {
		console.log(tour);

		// PAGE DASHBOARD - SEARCHER
		if (tour._options.name === 'searcher-field4') {
			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 3 || tour._current === 4 || tour._current === 5) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE AUDITION FORM - SEARCHER
		if (tour._options.name === 'searcher-field6') {
			if (tour._current === 3) {
				$('.audition-forms-step.audition-details .audition-forms-header').trigger('click');
			}
			if (tour._current === 7) {
				$('.audition-forms-step.audition-recording .audition-forms-header').trigger('click');
			}
			if (tour._current === 9) {
				$('.audition-forms-step.audition-contract .audition-forms-header').trigger('click');
			}
			if (tour._current === 10) {
				$('.audition-forms-step.audition-profile .audition-forms-header').trigger('click');
			}
		}

		// PAGE FICHE AUDITION - SEARCHER
		if (tour._options.name === 'searcher-field8') {
			if (tour._current === 3) {
				$('.audition-actions-btn').trigger('click');
			}
			// RESPONSIVE SIDE BREAKPOINT
			if ($('.resp-detector-side-bp').css('visibility') === 'visible') {
				if (tour._current === 1) {
					$('.audition-single-details-btn.close').trigger('click');
				}
				if (tour._current === 2) {
					$('.audition-single-details-btn:not(.close)').trigger('click');
				}
			}
		}

		// PAGE DASHBOARD - ARTIST
		if (tour._options.name === 'artist-field4') {
			if (tour._current === 1 || tour._current === 2) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.header-account-btn:not(.close)').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					$('.header-account-responsive-btn').trigger('click');
				}
			}

			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 3 || tour._current === 5) {
					leftMenuBtn.trigger('click');
				}
			}
		}
		
		// PAGE MODIF PROFIL - ARTISTE
		if (tour._options.name === 'artist-field6') {
			if (tour._current === 2) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=personnal-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 4) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=more-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('more-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 8) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=agency-link]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE FICHE AUDITION - ARTISTE
		if (tour._options.name === 'artist-field8') {
			if (tour._current === 2 || tour._current === 5) {
				$('.audition-actions-btn').trigger('click');
			}
		}

		// PAGE DASHBOARD - AGENCY
		if (tour._options.name === 'agency-field4') {
			if (tour._current === 1 || tour._current === 3) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.header-account-btn:not(.close)').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					$('.header-account-responsive-btn').trigger('click');
				}
			}

			// // RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 3 || tour._current === 7) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE MODIF PROFIL - AGENCY
		if (tour._options.name === 'agency-field6') {
			if (tour._current === 1) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 2) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('more-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 3) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 4) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('social');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 5) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('preferences');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 6) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 10) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE SUBSCRIPTIONS - AGENCY
		if (tour._options.name === 'agency-field9') {
			if (tour._current === 2) {
				$('.table-outer-ctn').animate({scrollLeft: $('.hijack-user-btn').position().left}, 300);
			}
			if (tour._current === 3) {
				$('.table-outer-ctn').animate({scrollLeft: $('.modify-artist-subscription-table-btn').position().left}, 300);
			}
		}
	};

	var saveTourSeen = function(tour) {
		// console.log(tour._options.name);
		refresh = false;
		$('.toggle-guide-check').trigger('click');
	};

	var saveGuideData = function() {
		var t = $(this);
		var popup = t.closest('.popup');
		var seeCurrGuide = t.hasClass('confirm-see-guide-btn');
		var cancelGuide = t.hasClass('cancel-see-guide-btn');
		var currGuideNames = $('input[name=curr-guides]').val().split(',');

		var data = {
			id: gendataId,
			field1: 'guide',
			field2: personId,
			ajax: true
		};

		if (popup.length > 0) {
			var checkboxChecked = popup.find('.form-check-input').prop('checked')
			
			data['field3'] = !checkboxChecked;

			// if "do not ask again" checked 
			if (checkboxChecked) {
				$('input[name=all-guides]').val().split(',').forEach(function(field) {
					// if field is not current page guide and if show/hide guide value doesn't already exist for that field
					if (currGuideNames.indexOf(field) === -1 && $('input[name=guide-' + field + ']').val().length === 0) {
						data[field.split('-')[1]] = seeCurrGuide ? true : false;
					}
				});
			}
		}

		currGuideNames.forEach(function(el) {
			data[el.split('-')[1]] = seeCurrGuide ? true : false;
		});
		popup.addClass('is-processing');
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: data,
			success: function (response) {
				// console.log(response);
				if (!cancelGuide) {
					window.location.reload();
				} else {
					$('.js-popup-close-btn', popup).click();
					popup.removeClass('is-processing');
				}
			}
		});
	};

	var togglePageGuide = function() {
		var t = $(this);
		var field = t.attr('name').split('-')[1];

		var data = {
			id: gendataId,
			field1: 'guide',
			field2: personId,
			ajax: true
		};

		data[field] = t.prop('checked');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: data,
			success: function (response) {
				if (refresh) {		
					$('.whole-container').addClass('is-processing');
					// console.log(response);
					window.location.reload();
				}
				refresh = true;
			}
		});
	};

	var init = function() {
		gendataId = $('input[name=guide-id]').val();
		personId = $('input[name=person-id]').val();
		leftMenu = $('.mobile-side-menu.left');
		leftMenuBtn = $('.site-header-menu-toggle-btn');
		accountNav = $('.account-nav-select');
		isDev = $('html').data('is-dev') === true || $('html').data('is-staging') === true;

		refresh = true;

		if ($('input[name=guide-prev]').length > 0) {
			prev = $('input[name=guide-prev]').val();
		}

		if ($('input[name=guide-next]').length > 0) {
			next = $('input[name=guide-next]').val();
		}

		if ($('input[name=guide-end]').length > 0) {
			end = $('input[name=guide-end]').val();
		}

		var initGuideInputs = $('input[name=init-guide]');
		if (initGuideInputs.length > 0) {
			setTimeout(function() {
				initGuideInputs.each(function() {
					initGuide($(this).val(), $(this).data('total-steps'));
				});
			}, 350);
		}

		$('.confirm-see-guide-btn').click(saveGuideData);
		$('.cancel-see-guide-btn').click(saveGuideData);
		$('.toggle-guide-check').change(togglePageGuide);
	};
	
	$(window).ready(function () {
		init();
	});

	Fw.component.export('guide', {
		initGuide: initGuide
	});

})(jQuery);

